module.exports = __webpack_public_path__ + "img/failure.845fc27.png";